function getFileName(url) {
  const name = url.split("/");
  return name.pop();
}

function fileDownload(url, cb = () => {}, download = true) {
  const filename = getFileName(url);

  fetch(url)
    .then((response) => {
      return response.blob();
    })
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const tempLink = document.createElement("a");

      tempLink.style.display = "none";

      tempLink.href = blobUrl;

      if (download) {
        tempLink.setAttribute("download", filename);
      } else {
        tempLink.setAttribute("target", "_blank");
      }
      document.body.appendChild(tempLink);

      tempLink.click();

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(tempLink);
      });

      cb();
    });
}

const isWeChat = (function () {
  var ua = window.navigator.userAgent.toLowerCase();
  // eslint-disable-next-line eqeqeq
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
})();

function urlExists(url) {
  const http = new XMLHttpRequest()
  http.open('HEAD', `${url}?${Math.random().toString(36).slice(-8)}`, false)
  http.send()
  return http.status !== 404
}

export { fileDownload, isWeChat, urlExists };
